import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, forwardRef, HostBinding, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Currency, CurrencyFilters } from 'src/app/commons/models/currency.model';
import * as CurrencyActions from 'src/app/store/actions/currency.actions';
import { AppState } from 'src/app/store/reducers';


export const CURRENCY_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => CurrencyFieldComponent),
};

@Component({
  selector: "app-currency-field",
  templateUrl: "./currency-field.component.html",
  styleUrls: ["./currency-field.component.scss"],
  providers: [CURRENCY_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class CurrencyFieldComponent
  implements ControlValueAccessor, MatFormFieldControl<Currency> {
  private unsubscribe$ = new Subject<void>();
  private _value: Currency;
  private _disabled = false;

  private _required = false;

  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "currency-selection-field";
  autofilled?: boolean;
  currencyAriaDescribedBy?: string;


  @Input()
  currencyFilters: CurrencyFilters;

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    @Optional() @Self() public ngControl: NgControl
  ) {

    this.actions$
      .pipe(
        ofType(CurrencyActions.currencySelected),
        takeUntil(this.unsubscribe$),
        map(({ currency }) => (currency ? new Currency(currency) : null))

      )
      .subscribe((currency) => (this.value = currency));
        if (this.ngControl != null) {
          this.ngControl.valueAccessor = this;
        }
    }
  stateChanges = new Subject<void>();
  id: string;


  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {
    //TODO
  }
  onContainerClick(event: MouseEvent): void {
    if (!this.disabled) {
      if ((event.target as Element).tagName.toLowerCase() != "mat-icon") {
        this.selectCurrency();
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  selectCurrency() {
    this.store$.dispatch(CurrencyActions.selectCurrency({ filters: this.currencyFilters}));
  }

  clearCurrency() {
    this.value = null;
  }

  set value(value: Currency) {
    this._value = value;
    this.notifyValueChange();
    this.stateChanges.next();
  }

  get value(): Currency {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: Currency): void {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
